import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { deleteDivisa, getDivisas } from "../../../../api/divisa";
import { postLog } from "../../../../api/log";
import { LOGS } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
  buttonsStyle,
  dateFormatter,
  getCurrentTablePage,
} from "../../../components/tables/table";

function getData(divisas) {
  let data = [];
  for (let i = 0; i < divisas.length; ++i) {
    const elem = {};
    const divisa = divisas[i];

    elem.name = divisa?.name;
    elem.divisa = divisa?.divisa;
    elem.createdAt = divisa?.createdAt;
    elem.id = divisa?._id;

    data = data.concat(elem);
  }
  return data;
}

export default function DivisasPage() {
  const [data, setData] = useState([]);
  const [selectedDivisa, setSelectedDivisa] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const location = useLocation();

  const history = useHistory();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              history.push({
                pathname: "/currencies/" + cell + "/edit",
                state: {
                  page: getCurrentTablePage(location),
                },
              });
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setSelectedDivisa(elem);
              setOpenConfirmDialog(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Name", sort: true },
    { dataField: "divisa", text: "Sign", sort: true },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: dateFormatter,
      sort: true,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getDivisas()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get currencies.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Currenies list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                history.push({
                  pathname: "/currencies/edit",
                  state: {
                    page: getCurrentTablePage(location),
                  },
                });
              }}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table data={getData(data)} columns={columns} />
          <ConfirmDialog
            title={"Are you sure you want to delete this currency?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteDivisa(selectedDivisa?._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    postLog(
                      loggedUser,
                      LOGS.FIELDS.DIVISAS,
                      `${LOGS.ACTIONS.DELETE}-${selectedDivisa?.name}`
                    );
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "Currency deleted successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not delete currency.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
